<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <h1>
          {{ $t("message.slideSixTitle") }}
        </h1>
        <h2>
          {{ $t("message.slideSixSubTitle") }}
        </h2>
      </v-col>
      <v-col :cols="colSize">
        <span style="font-size: large;">
          {{ $t("message.slideSixZipCodeQuestion") }}
        </span>
        <v-text-field
          outlined
          style="text-transform: capitalize"
          :label="$t(`message.zipCode`)"
          v-model="postalCode"
          @change="
            setEx1({
              field: `postalCode`,
              text: postalCode
            })
          "
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="colSize">
        <span style="font-size: large;">
          {{ $t("message.slideSixSelectOneQuestion") }}
        </span>
        <v-select
          style="padding-top: 2%"
          outlined
          :label="$t(`message.slideSixSelectOneLabel`)"
          v-model="transportationModesAndServices"
          item-text="label"
          item-value="value"
          @change="
            setEx1({
              field: `transportationModesAndServices`,
              text: transportationModesAndServices
            })
          "
          :items="$t(`message.slideSixSelectOneChoices`)"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.label }}</span>
            </v-chip>
            <span v-if="index === 1" class="text caption"
              >(+{{ transportationModesAndServices.length - 1 }} others)</span
            >
          </template></v-select
        >
      </v-col>
      <v-col :cols="colSize">
        <span style="font-size: large;">
          {{ $t("message.slideSixSelectTwoQuestion") }}
        </span>
        <v-select
          style="padding-top: 2%"
          outlined
          :label="$t(`message.slideSixSelectTwoLabel`)"
          v-model="agencies"
          item-text="label"
          item-value="value"
          @change="
            setEx1({
              field: `agencies`,
              text: agencies
            })
          "
          :items="$t(`message.slideSixSelectTwoChoices`)"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.label }}</span>
            </v-chip>
            <span v-if="index === 1" class="text caption"
              >(+{{ agencies.length - 1 }} others)</span
            >
          </template></v-select
        >
      </v-col>
      <v-col :cols="colSize">
        <span style="font-size: large;">
          {{ $t(`message.slideSixSelectThreeQuestion`) }}
        </span>
        <v-select
          style="padding-top: 2%"
          outlined
          :label="$t(`message.slideSixSelectThreeLabel`)"
          v-model="interestGroup"
          item-text="label"
          item-value="value"
          @change="
            setEx1({
              field: `interestGroup`,
              text: interestGroup
            })
          "
          :items="$t(`message.slideSixSelectThreeChoices`)"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.label }}</span>
            </v-chip>
            <span v-if="index === 1" class="text caption"
              >(+{{ interestGroup.length - 1 }} others)</span
            >
          </template></v-select
        >
      </v-col>
      <v-col :cols="colSize">
        <span style="font-size: large;">
          {{ $t(`message.slideSixSelectFourQuestion`) }}
        </span>
        <v-select
          style="padding-top: 2%"
          outlined
          :label="$t(`message.slideSixSelectFourLabel`)"
          v-model="transportationServiceOrFrieghtProvider"
          item-text="label"
          item-value="value"
          @change="
            setEx1({
              field: `transportationServiceOrFrieghtProvider`,
              text: transportationServiceOrFrieghtProvider
            })
          "
          :items="$t(`message.slideSixSelectFourChoices`)"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.label }}</span>
            </v-chip>
            <span v-if="index === 1" class="text caption"
              >(+{{
                transportationServiceOrFrieghtProvider.length - 1
              }}
              others)</span
            >
          </template></v-select
        >
      </v-col>
      <v-col :cols="colSize">
        <span style="font-size: large;">
          {{ $t(`message.slideSixSelectFiveQuestion`) }}
        </span>
        <v-select
          style="padding-top: 2%"
          outlined
          :label="$t(`message.slideSixSelectFiveLabel`)"
          v-model="govEmpOrOffical"
          item-text="label"
          item-value="value"
          @change="
            setEx1({
              field: `govEmpOrOffical`,
              text: govEmpOrOffical
            })
          "
          :items="$t(`message.slideSixSelectFiveChoices`)"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.label }}</span>
            </v-chip>
            <span v-if="index === 1" class="text caption"
              >(+{{ govEmpOrOffical.length - 1 }} others)</span
            >
          </template></v-select
        >
      </v-col>
      <v-col :cols="colSize">
        <span style="font-size: large;">
          {{ $t(`message.slideSixSelectSixQuestion`) }}
        </span>
        <v-select
          style="padding-top: 2%"
          outlined
          :label="$t(`message.slideSixSelectSixLabel`)"
          v-model="otherStakeholderTypes"
          item-text="label"
          item-value="value"
          @change="
            setEx1({
              field: `otherStakeholderTypes`,
              text: otherStakeholderTypes
            })
          "
          :items="$t(`message.slideSixSelectSixChoices`)"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.label }}</span>
            </v-chip>
            <span v-if="index === 1" class="text caption"
              >(+{{ otherStakeholderTypes.length - 1 }} others)</span
            >
          </template></v-select
        >
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    file: { type: String },
    slideNumber: { type: Number },
    updateFile: { type: Function }
  },
  mounted() {
    this.newSlideNumber = this.slideNumber;
    this.audio = new Audio(this.file);
    this.audio.play();
  },
  data() {
    return {
      postalCode: "",
      transportationModesAndServices: [],
      agencies: [],
      interestGroup: [],
      transportationServiceOrFrieghtProvider: [],
      govEmpOrOffical: [],
      otherStakeholderTypes: [],
      audio: null,
      newSlideNumber: null
    };
  },
  computed: {
    ...mapState("response", ["finalPayload"]),
    colSize() {
      if (this.$vuetify.breakpoint.xs) {
        return "12";
      }
      return "6";
    },
    cols4() {
      if (this.$vuetify.breakpoint.xs) {
        return "12";
      }
      return "4";
    }
  },
  watch: {
    "$i18n.locale": function() {
      if (this.newSlideNumber === 5) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.updateFile(5);
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    },
    slideNumber(current) {
      this.newSlideNumber = current;
      if (current !== 5) {
        this.audio.pause();
        this.audio.currentTime = 0;
      } else {
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    }
  },
  methods: {
    ...mapActions("response", ["setEx1"])
  }
};
</script>
